import { useTranslation } from 'react-i18next';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CardBadge, {
  CardBadgeProps,
} from '../../../../../../shared/components/CardBadge';
import { PricingIcons } from '../../../../../../helpers/icons/icons';
import { PricingIconTypes } from '../../../../../../types/enums';

export interface ProductBadgeProps extends CardBadgeProps {
  label?: string;
  iconId?: keyof typeof PricingIconTypes;
  hexColor?: string;
}

export default function ProductBadge(props: ProductBadgeProps) {
  const { label, iconId, hexColor, ...cardBadgeProps } = props;
  const { t } = useTranslation();
  const Icon = iconId ? PricingIcons[iconId] : AutoAwesomeIcon;

  return (
    <CardBadge
      startIcon={<Icon fontSize="small" />}
      hexColor={hexColor}
      {...cardBadgeProps}
    >
      {label ||
        t('site.pricing.products-selection.primary-product-card.badge.label')}
    </CardBadge>
  );
}
